import { createContext, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const IdleTimerContext = createContext();

export const IdleTimerProvider = ({ children, timeoutMinutes = 60 }) => {
  const navigate = useNavigate();

  useEffect(() => {
    let timeoutId;

    const handleAutoLogout = () => {
      // Clear authentication/session data
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("client");

      sessionStorage.removeItem("user");

      // Redirect immediately to account entry page
      navigate("/", { replace: true });
    };

    const resetTimer = () => {
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        handleAutoLogout();
      }, timeoutMinutes * 60 * 1000);
    };

    const events = [
      "mousedown",
      "mousemove",
      "keypress",
      "scroll",
      "touchstart",
    ];

    const handleActivity = () => {
      resetTimer();
    };

    events.forEach((event) => {
      window.addEventListener(event, handleActivity);
    });

    // Start timer when provider mounts
    resetTimer();

    return () => {
      clearTimeout(timeoutId);

      events.forEach((event) => {
        window.removeEventListener(event, handleActivity);
      });
    };
  }, [timeoutMinutes, navigate]);

  return (
    <IdleTimerContext.Provider value={{}}>
      {children}
    </IdleTimerContext.Provider>
  );
};

export const useIdleTimer = () => useContext(IdleTimerContext);